import React from 'react';

import { createSvgIcon } from '../../utils/createSvgIcon';

export const SupplyIcon = createSvgIcon(
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2977_20871)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7655 33.17L31.531 26.1107V12.0593L19.7655 5L8 12.0593L8 26.1107L19.7655 33.17ZM9.98854 24.9848V14.4162L18.7712 19.9054V30.2544L9.98854 24.9848ZM20.7598 30.2544V19.8953L29.5425 14.4147V24.9848L20.7598 30.2544ZM28.632 12.6389L19.7575 18.1768L10.8979 12.6396L19.7655 7.31902L28.632 12.6389Z"
        fill="#FFFEF4"
      />
    </g>
    <defs>
      <clipPath id="clip0_2977_20871">
        <rect width="24" height="29" fill="white" transform="translate(8 5)" />
      </clipPath>
    </defs>
  </svg>,
  'Supply'
);
